export class CancelError extends Error {
  public constructor(message?: string) {
    super(message);
    this.name = 'CancelError';

    Object.setPrototypeOf(this, CancelError.prototype);
  }
}
